var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.066,
    height: 20.066,
    viewBox: "0 0 20.066 20.066",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-time",
    "data-name": "Icon ionic-ios-time",
    d: "M13.408,3.375A10.033,10.033,0,1,0,23.441,13.408,10.032,10.032,0,0,0,13.408,3.375Zm.675,10.9a.677.677,0,0,1-.675.675H8.777a.675.675,0,1,1,0-1.351h3.955V7.234a.675.675,0,0,1,1.351,0Z",
    transform: "translate(-3.375 -3.375)",
    fill: "#ec6321"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeicon);
export default __webpack_public_path__ + "static/media/time icon.02a75bc260a675ca987036312d64226b.svg";
export { ForwardRef as ReactComponent };